
export const QUERY_KEYS = {
    filesCasosByUser: 'useGetFilesCasoByUsers',
    vizualizacionDescargaDocumento: 'useVizualizacionDescargaDocumento',
} as const;